import React, {useState} from 'react';
import './assets/style/index.scss';
import { BrowserRouter as Router,Switch, Route } from "react-router-dom";
import Container from '@material-ui/core/Container';

import Location from './pages/Location'
import Locations from './pages/Locations'
import Header from './components/Header'
import LocationsMap from './components/LocationsMap'
import LocationsList from './components/LocationsList'
import CP from '@material-ui/core/CircularProgress';

function App() {
  const [expand, setExpand] = useState(false)
  const [loading, setLoading] = useState(true)

  const expandToggle = () => {
    setExpand(v => !v)
    console.log('expanding');
  };

  return (
    <Router>
      <div className="App">
        {/*<Header onExpand={expandToggle} />*/}
        <LocationsMap />
        { loading && <div  id="loading"> <CP /><span>Loading</span> </div> }
        <main>
          <Container>

            <Switch>
              <Route path="/location"><Location /></Route>
              <Route path="/locations"><Locations /></Route>
            </Switch>
          </Container>
        </main>
        {/*<MapLocations/>*/}
        <LocationsList expand={expand} onChange={expandToggle} />
      </div>
    </Router>
  );
}

export default App;
